import React, { useState } from 'react';
import './Playground.css';
import TopBar from '../dashboard/TopBar';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const Playground = () => {
  const [isNotified, setIsNotified] = useState(false);

  const handleNotifyClick = () => {
    // Disable the button immediately to prevent multiple clicks
    if (isNotified) return;

    setTimeout(() => {
      setIsNotified(true);
    }, 500); // 500ms delay
  };

  return (
    <div className="playground-container">
      <TopBar disableDashboardLink={true} />
      <main className="playground-content">
        <div className="coming-soon-container">
          <h2 className="coming-soon-text">Playground Coming Soon</h2>
          <a 
            href="https://github.com/shadi-fsai/a1facts" 
            target="_blank" 
            rel="noopener noreferrer"
            className="github-link"
          >
            View on GitHub
          </a>
          <div className="notify-container">
            <button 
              className="notify-button" 
              onClick={handleNotifyClick}
              disabled={isNotified}
            >
              Email me when Playground is ready
            </button>
            {isNotified && <CheckCircleIcon className="checkmark-icon" />}
          </div>
        </div>
      </main>
    </div>
  );
};

export default Playground;
